






















import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component
export default class BusinessManagement extends Vue {
  @Getter('auth/getBusinessManagementMenus') businessManagementMenus!;
  // data
  defaultActiveTabIndex: any = null;
  activeSingleContent = false;
  // computed
  get isActiveSingleContent() {
      return this.activeSingleContent;
  }

  // watch
  @Watch('$route', {immediate: true, deep: true})
  handleRoutePathChange(n, o) {
      // 默认路由
      const rootRouteName = '企业管理';
      if(this.businessManagementMenus.length === 0) {
          this.$router.replace({
              name: 'home_403',
              params: {
                  routeName: rootRouteName,
              }
          });
      } else if (n.name === rootRouteName) {
          this.$router.replace({
              name: this.businessManagementMenus[0].routeName,
          });
      } else {
          this.checkUrlAndSetActiveTab(n);
      }
  }
  @Watch('businessManagementMenus', { immediate: true })
  businessManagementMenusChange(n) {
      if (n) {
          this.checkUrlAndSetActiveTab(this.$route);
      }
  }
  // methods
  getImgSrc(url): string {
    return require('@/assets/img/business-manager/icon_' + url + '@2x.png');
  }
  switchManageContent(menu, index): void {
    if (index + '' === this.defaultActiveTabIndex) {
      return;
    }
    this.$router.push({
      name: menu.routeName,
    });
  }
  checkUrlAndSetActiveTab({path, name, meta}): void {
    const matchedIndex = _.findIndex(this.businessManagementMenus, menu => {
      return name.indexOf(menu.routeName) > -1;
    });
    if (matchedIndex > -1) {
      this.defaultActiveTabIndex = matchedIndex + '';
    }
    if (meta.projectDetailIndex > 1) {
      this.activeSingleContent = true;
    } else {
      this.activeSingleContent = false;
    }

  }

}
